<script>import TimeSeriesPlot from "../../d3/TimeSeriesPlot.svelte";
import Swatches from "../../../components/legend/Swatches.svelte";
import { scaleOrdinal } from "d3";
export let plotDefinitions;
export let startMarker = void 0;
export let endMarker = void 0;
$:
  swatchLabels = plotDefinitions.filter((plot) => plot.type.name.indexOf("SignalThresholdPlot") !== -1).flatMap((plot) => plot.properties.splineLabels);
$:
  swatchColors = plotDefinitions.filter((plot) => plot.type.name.indexOf("SignalThresholdPlot") !== -1).flatMap((plot) => plot.properties.colors);
</script>

<TimeSeriesPlot
  role={"plot"}
  showAxis={true}
  separate={true}
  bind:startMarker
  bind:endMarker
>
  {#each plotDefinitions as plotDefinition}
    <svelte:component
      this={plotDefinition.type}
      {...plotDefinition.properties}
    />
  {/each}
</TimeSeriesPlot>
<div>
  <div style="display:inline-block; margin-top:1rem; text-align:center">
    <Swatches
      scale={scaleOrdinal(swatchLabels, swatchColors)}
      type={"circle"}
    />
  </div>
</div>
